import { render, staticRenderFns } from "./AddOrganization.vue?vue&type=template&id=4718dad8&scoped=true&"
import script from "./AddOrganization.vue?vue&type=script&lang=js&"
export * from "./AddOrganization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4718dad8",
  null
  
)

export default component.exports